export const values = <K extends string, V>(record: Record<K, V>): Array<V> => Object.values(record);
